// This file is auto-generated using the 'icon-generator' package.
// Any changes made to this file manually will be lost the next time the
// file is generated

import * as React from "react";
import { MappedProps, PassedProps, useMappedProps } from "./useMappedProps";

const Icon: React.ComponentType<
  Omit<React.SVGProps<SVGSVGElement>, keyof MappedProps> & PassedProps
> = (passedProps) => {
  const props = useMappedProps(passedProps);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={1024}
      height={312}
      viewBox="-1.373 -1.373 159.212 48.528"
      {...props}
    >
      <path
        d="M156.465 22.92c0 13.31-8.862 22.861-21.904 22.861-12.334 0-21.495-8.77-21.495-22.861C113.066 7.788 123.95 0 134.971 0c10.566 0 21.494 7.378 21.494 22.92zm-10.67 0c0-6.358-3.075-13.72-11.059-13.72-7.246 0-11.054 6.22-11.054 13.72 0 8.428 4.697 13.73 11.054 13.73 7.984 0 11.06-7.295 11.06-13.73M109.155 41.621c-2.607 1.748-8.1 4.116-15.59 4.116-14.712 0-21.983-10.151-21.983-22.558C71.582 9.214 81.465 0 94.38 0c6.391 0 10.498 1.064 14.136 2.852l-3.73 8.603c-2.78-1.167-5.977-1.85-9.766-1.85-9.332 0-12.5 5.585-12.5 13.295 0 8.32 4.248 13.721 11.66 13.721 2.675 0 4.692-.576 5.307-.976V27.9h-7.514l.01-8.76h17.172v22.481M58.896 45.02c-1.455-5.333-3.906-9.39-5.922-11.983-1.7-2.187-3.023-2.656-3.023-2.656a41.43 41.43 0 0 1-3.584-.025V45.02H36.094V1.177C38.257.82 39.804.635 42.08.425a75.905 75.905 0 0 1 7.066-.322c3.466 0 6.41.385 8.818 1.147 2.427.762 4.394 1.812 5.928 3.145a11.625 11.625 0 0 1 3.383 4.794c.723 1.773 1.084 3.663 1.084 5.68 0 2.65-.644 5.234-2.06 7.43-1.26 1.959-3.364 3.96-5.552 5.343v.195c4.883 2.231 7.642 9.419 10.322 17.183H58.896zm-.84-29.903c0-1.85-.673-3.34-1.996-4.346-1.329-1.05-3.16-1.562-5.372-1.591-.249-.01-1.2.005-1.772.024-.571.015-2.08.151-2.549.24v12.631c.684.078 2.11.142 3.262.142 2.46 0 4.741-.679 6.191-1.802 1.455-1.167 2.237-3.042 2.237-5.298M0 34.521V.723h30.17l.006 9.423H10.273v7.583H27.12l.005 8.95h-16.85v4.737c0 2.979 1.747 4.233 4.028 4.233h16.684l.015 9.37H10.42C2.71 45.02 0 41.46 0 34.522"
        fill="#ee003b"
      />
    </svg>
  );
};

const ErgoIcon = Icon;
export default ErgoIcon;
